import { getLOLMatchRecordCardsData } from '_api/bbs/post'
import Vue from 'vue'
const CptName = 'ComLOLMatchRecordCard'
const CptHeightEnum = {
  'ban_pick': '149px',
  'timeline': '313px'
}
class LOLMatchRecordCards {
  #promise
  #resolve
  #article
  constructor (article) {
    this.cards = []
    this.#article = article
    this.results = {}
    this.#promise = new Promise(resolve => this.#resolve = resolve)
  }

  addCards (node) {
    if (
      node.dataset 
      && node.dataset.lol_matchid 
    ) {
      this.loadCard()
      let card = this.generateCardData(node)
      this.cards.push(card)
      return card
    }
    return node
  }

  loadCard () {
    if (!this.is_load_card) {
      this.dynImport()
      this.is_load_card = true
    }
  }

  dynImport () {
    import('./index.vue').then(cpt => {
      Vue.component(CptName, cpt.default)
      this.cards.forEach(item =>item.cpt = CptName)
    })
  }

  generateCardData (node) {
    return {
      cpt: 'ComCardPlaceholder',
      data: {
        request: (id) => this.handleResult(id),
        type: node.dataset.lol_type,
        game_id: node.dataset.lol_matchid,
        id: node.dataset.matchid,
        placeholder_style: {
          height: CptHeightEnum[node.dataset.lol_type],
        }
      }
    }
  }

  request () {}

  async handleResult (id) {
    if (this.#article.options.preload) return
    if (!this.results[id]) {
      let { data: {result, status}} = await getLOLMatchRecordCardsData({
        game_id: id,
        for_news: 1
      })
      // test
      // if (id == '7341448039') {
      //   result = require('../../mock/dota2_news.json').result
      // }
      if (status != 'ok') {
        return
      }
      this.results[id] = result
    }
    return this.results[id]
  }
}
export default LOLMatchRecordCards